const cookieInit = function () {
    if (jQuery.cookie) {
        const cookieBanner = $('[data-id="cookie-banner"]');
        const closeBtn = $('[data-id="cookie-close"]');
        const acceptBtn = $('[data-id="cookie-accept"]');
        const manageBtn = $('[data-id="cookie-manage"]');

        // Accept cookies button
        acceptBtn.on('click', function () {
            CookieControl.acceptAll();
            cookieBanner.hide();
            $.cookie("hideCookieBanner", true, { expires: 365, path: "/" });
        });

        // Open cookie preferences panel
        manageBtn.on('click', function () {
            CookieControl.open();
            cookieBanner.hide();


            // Sometimes the Civic plugin does not force focus onto close button
            // Add setInterval to ensure close button is present, then focus onto it
            // Updated 2025 to change h3 headings to h2
            const checkForButton = setInterval(() => {
                const closeButton = $('#ccc-close');
                if (closeButton.length) {
                    closeButton.focus();
                    clearInterval(checkForButton);
                }

            }, 100);
        });

        if (!$.cookie("hideCookieBanner")) cookieBanner.show();

        closeBtn.on("click", function (evt) {
            evt.preventDefault();
            cookieBanner.hide();
        });
    }

    if (Modernizr.mq('only all')) {
        const moveCookie = function () {
            $('[data-id="cookie-banner"]').prependTo('[data-id="mobile-cookie-location"]');
        };

        const moveCookieBack = function () {
            $('[data-id="cookie-banner"]').prependTo('div.m-header');
        };

        enquire.register("screen and (max-width:47.938em)", {
            match: function () {
                moveCookie();
            },
            unmatch: function () {
                moveCookieBack();
            }
        }, true);
    }
};
